/* actionsBarWrapper-compiled.tsx generated by @compiled/babel-plugin v0.36.1 */
import "./actionsBarWrapper-compiled.compiled.css";
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
import { actionsBarClassName } from './styles';
var wrapperStyles = null;
var fixedActionBarStyle = null;
export var ActionsBarWrapper = function ActionsBarWrapper(props) {
  return /*#__PURE__*/React.createElement("div", {
    id: "actionsBarWrapper",
    "data-testId": "actionsBarWrapper",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    className: ax(["_v564ybtr _2lx2vrvc _1n261q9c _zulpu2gc _kqswstnw _154iidpf _1xi2idpf _1e0c1txw _1bahusic _ca0qu2gc _n3tdu2gc _u5f3u2gc _19bvu2gc _tzy4idpf", props.isFixed && "_tzy4kb7n", actionsBarClassName]),
    onClick: function onClick(event) {
      event.stopPropagation();
      event.preventDefault();
    }
  }, props.children);
};
ActionsBarWrapper.displayName = 'ActionsBarWrapper';